import React from 'react';
import FormikSearchDropdown from 'src/components/formik/FormikSearchDropdown/FormikSearchDropdown';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import PropTypes from 'prop-types';
import { areaSearchAPI } from 'src/api/AreaApi';

const AreaDropDown = ({
    value,
    name,
    readOnly,
    cityId,
}) => (
    <FormikSearchDropdown
        name={name}
        placeholder="Select Area"
        displayKeyPath={[
            'areaName',
        ]}
        valueKeyPath="_id"
        defaultValueFetchByKeyPath="_id"
        whereClauseKeysPaths={[
            'areaName',
        ]}
        api={areaSearchAPI}
        apiCallAddonData={{
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
        }}
        value={value}
        whereConditions={{
            cityId,
        }}
        disabled={!cityId || readOnly}
    />
);

AreaDropDown.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    value: PropTypes.any,
    name: PropTypes.string.isRequired,
    cityId: PropTypes.string,
    readOnly: PropTypes.bool,
};

AreaDropDown.defaultProps = {
    // eslint-disable-next-line react/forbid-prop-types
    cityId: null,
    value: '',
    readOnly: false,
};

export default AreaDropDown;
